import React from "react";
import PropTypes from "prop-types";

import { Grid, Typography } from "@mui/material";

import { CommonModal, PrimaryButton, SecondaryButton } from "../index";
import DeleteConfirmation from "../../../Icons/img_delete_confirmation.svg";

import { trakrefFontFamily } from "../../../utils";
import { Grey1, Grey3 } from "../../../color_utils"

const DeleteModal = ({
  open,
  title,
  description,
  buttonText,
  onConfirm,
  onClose,
  showImage,
  renderCloseIcon,
}) => (
  <CommonModal open={open} close={onClose} renderCloseIcon={renderCloseIcon}>
    <Grid container spacing={2}>
      {showImage &&
      <Grid item xs={12} align="center">
        <img
          style={{ paddingTop: "1%", paddingBottom: "5%" }}
          src={DeleteConfirmation}
          width="275px"
          height="250px"
        />
      </Grid>}
      <Grid item xs={12} style={{ marginTop: !showImage && '2%',}}>
        <Typography
          variant="h5"
          sx={{
            "&.MuiTypography-root": {
              fontFamily: trakrefFontFamily,
              color: Grey1,
            },
          }}
          align="center"
        >
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          sx={{
            "&.MuiTypography-root": {
              fontFamily: trakrefFontFamily,
              fontSize: 14,
              color: Grey3,
            },
          }}
          align="center"
        >
          {description}
        </Typography>
      </Grid>
      <Grid item xs={12} align="center">
        <PrimaryButton
          useLargeButton
          buttonText={buttonText}
          onClick={onConfirm}
          width={75}
        />
      </Grid>
      <Grid item xs={12} align="center">
        <SecondaryButton
          useLargeButton
          buttonText="Cancel"
          onClick={onClose}
          width={75}
        />
      </Grid>
    </Grid>
  </CommonModal>
);

DeleteModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  showImage: PropTypes.bool,
  renderCloseIcon: PropTypes.bool,
};

DeleteModal.defaultProps = {
  open: false,
  buttonText: "Yes, Delete",
  showImage: true,
  renderCloseIcon: true
};

export default DeleteModal;
